import { InfoCircleOutlined } from '@ant-design/icons'
import TooltipWrapper from '@pages/Admin/CourseSettings/components/TooltipWrapper/TooltipWrapper'
import classNames from 'classnames'
import { FC } from 'react'
import { END_DATE_COLUMN_HINT } from '../../utils/constants'
import cn from './index.module.css'

interface IEndDateWithProcessedColumnHeader {
  className?: string
}

const iconProps = {
  onPointerEnterCapture: undefined,
  onPointerLeaveCapture: undefined,
}

const EndDateWithProcessedColumnHeader: FC<IEndDateWithProcessedColumnHeader> = ({
  className,
}) => (
  <span className={classNames(cn.columnHeader, className)}>
    Дата завершения
    <TooltipWrapper title={END_DATE_COLUMN_HINT}>
      <span className={cn.infoIcon} aria-label="Подсказка по дате завершения">
        <InfoCircleOutlined {...iconProps} />
      </span>
    </TooltipWrapper>
  </span>
)

export default EndDateWithProcessedColumnHeader
